import { KvSyncApi } from '@ahaslides-product/frontend-toolkit'
import Vue from 'vue'
import config from '@/config'

export default KvSyncApi(Vue, config)
